import React from "react";

import { Switch } from "antd";

import { FontIcon } from "@companion-core/shared/app/Components/FontIcon";
import { PreferencesSwitchProps } from "./preferencesSwitch.model";
import { usePreferencesSwitch } from "./hooks/preferencesSwitch";

export const PreferencesSwitch = ({ entry, checked }: PreferencesSwitchProps) => {
  const { updatePreferences, isChecked, isPending, t } = usePreferencesSwitch({
    entry,
    checked,
  });

  return (
    <>
      <span className="body-text-3" data-testid={`preferences__section-switch-title-${entry.name}`}>
        {t(`my-account.preferences.${entry.name}.title`)}
        {" ("}
        {t(`my-account.preferences.${isChecked ? "checked" : "unchecked"}`)}
        {")"}
      </span>
      <div className="preferences__section-switch-content body-text-6">
        <span
          className="preferences__section-switch-description"
          data-testid={`preferences__section-switch-description-${entry.name}`}>
          {t(`my-account.preferences.${entry.name}.description`)}
        </span>
        <Switch
          data-testid={`preferences__section-switch-toggle-${entry.name}`}
          className="preferences__section-switch-toggle"
          loading={isPending}
          checked={isChecked}
          onChange={updatePreferences}
          checkedChildren={<FontIcon name="JP-Select" />}
          unCheckedChildren={<FontIcon name="JP-Close-bold" />}
        />
      </div>
    </>
  );
};
